import React from 'react';
import { useSelector } from 'react-redux';
import Accordion from '@Components/Accordion/Accordion';
import Divider from '@Components/Divider/Divider';
import useTranslate from '@Utils/hooks/useTranslate';
import LabeledInformation from './LabeledInformation';
import { DocumentState } from '../../DocumentDetails/DocumentDetails';
import {
	AccordionContentWrapper,
	DividerWrapper,
	SectionHeader,
} from '@Components/Card/cards/ShippingDetails/ShippingDetails.styled';

interface IProvidedDocument {
	orderWithPrepaid: boolean;
}

const ProvidedDocument = ({ orderWithPrepaid }: IProvidedDocument): JSX.Element => {
	const { translate } = useTranslate();
	const prepaidProcessCheckout = useSelector(
		(state: types.redux.IState) => state.persistentCheckout.prepaidProcessCheckout
	);
	const hbbWfbbProcessCheckout = useSelector(
		(state: types.redux.IState) => state.persistentCheckout.hbbWfbbProcessCheckout
	);

	const getPrepaidProvidedDocumentSubtitle = () =>
		translate(
			`sim-order-details.accordion.provided.document.subtitle-${
				hbbWfbbProcessCheckout?.customerIdType === DocumentState.NATIONAL
					? DocumentState.NATIONAL
					: DocumentState.RESIDENCE
			}`,
			hbbWfbbProcessCheckout?.expiryDate || ''
		);

	return (
		<>
			<Accordion
				subtitleColor={orderWithPrepaid ? 'black54' : 'black87'}
				isPrepaid={orderWithPrepaid}
				title={translate('shipping-details.accordion.provided.document')}
				subtitle={getPrepaidProvidedDocumentSubtitle()}
				icon="document"
			>
				<AccordionContentWrapper>
					<SectionHeader>
						{translate(
							`sim-order-details.accordion.provided-document.section-header-${
								prepaidProcessCheckout?.customerIdType === DocumentState.NATIONAL
									? DocumentState.NATIONAL
									: DocumentState.RESIDENCE
							}`
						)}
					</SectionHeader>
					<Divider marginBottom={8} />
					<LabeledInformation
						label={translate('sim-order-details.accordion.contact-data.data.civil-number')}
						data={prepaidProcessCheckout?.customerId}
					/>

					<Divider marginBottom={24} withoutLine />
				</AccordionContentWrapper>
			</Accordion>
			<DividerWrapper>
				<Divider />
			</DividerWrapper>
		</>
	);
};

export default ProvidedDocument;
